import gql from 'graphql-tag';
export const FRAGMENT_CTA_BUTTON = gql`
  fragment ctaButton on ComponentCtaButton {
    text_en
    text_de
    url
    external_link
    isButton: button
    overlay
    download {
      url
    }
  }
`;
